"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";

/** Error boundary zona (landing) — recovery tanpa kehilangan navbar/footer. */
export default function LandingZoneError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[landing-zone]", error);
  }, [error]);

  return (
    <div className="bg-background flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="text-foreground text-xl font-bold">
        Waduh, halaman ini gagal dimuat
      </h2>
      <p className="text-muted-foreground text-sm">
        Coba muat ulang. Kalau masih gagal, hubungi kami lewat pusat bantuan.
      </p>
      <div className="flex gap-3">
        <Button size="xl" onClick={reset}>
          Coba lagi
        </Button>
        <Button size="xl" variant="outline" render={<Link href="/" />}>
          Beranda
        </Button>
      </div>
    </div>
  );
}
